<template>
  <div
    v-click-outside="clickOutside"
    class="landing-page-time-modal"
    @click.stop="mobileStatus ? clickOutside() : false"
  >
    <div class="landing-page-time-modal__wrap">
      <div class="landing-page-time-modal-header">
        <div class="landing-page-time-modal-header__title">
          {{ formatDate }}
        </div>
      </div>
      <div class="landing-page-time-modal-content">
        <div class="landing-page-time-modal-content__list">
          <div
            v-for="time in workingHours"
            :key="time.id"
            class="landing-page-time-modal-content__item"
            :class="{'landing-page-time-modal-content__item_active': timing === time.value}"
            @click="selectTime(time)"
          >
            {{ time.value }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import workingHours from '@/constants/requestModalTiming';
import ClickOutside from 'vue-click-outside';
import moment from 'moment';
import MobileDetect from 'mobile-detect';

export default {
  name: 'RequestTimeModal',
  directives: {
    ClickOutside,
  },
  props: {
    timing: {
      type: String,
      default: () => '',
    },
    date: {
      type: [Date, String],
      default: () => new Date(),
    },
    showTiming: {
      type: Boolean,
      default: () => false,
    },
  },
  data: () => ({
    workingHours,
  }),
  computed: {
    mobileStatus() {
      const md = new MobileDetect(window.navigator.userAgent);
      const mobile = md.mobile();
      const tablet = md.tablet();
      return mobile !== null || tablet !== null;
    },
    language() {
      return this.$i18n.locale;
    },
    formatDate() {
      const date = this.date || new Date();
      return moment(date).locale(this.language).format('LL');
    },
  },
  beforeMount() {
    if (!this.date) {
      this.$emit('update:date', new Date());
    }
  },
  methods: {
    clickOutside() {
      this.$emit('update:showTiming', false);
    },
    selectTime(time) {
      this.$emit('update:timing', time.value);
      this.$emit('update:showTiming', false);
    },
  },
};
</script>

<style scoped lang="scss">
@import "src/sass/variables";
@import "src/sass/mixins";

.landing-page-time-modal {
  position: absolute;
  right: 0;
  width: 328px;
  height: 339px;
  background: $color-white;
  left: 372px;
  top: 20px;
  z-index: 111;

  @include desktop-small {
    top: -30px;
  }

  &__wrap {

    @include tablet-portrait {
      width: 328px;
      height: 339px;
      min-height: auto;
      min-width: auto;
      background: $color-white;
      z-index: 111;
    }

    @include mobile-middle {
      width: 328px;
    }

    @include mobile-small {
      width: 290px;
    }
  }

  @include tablet-portrait {
    z-index: 100;
    position: fixed;
    top: 0;
    left: 0;
    right: auto;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba($color-black, .5);
  }

  &-header {
    padding: 24px 24px 13px;
    border-bottom: 1px solid $color-alabaster;

    &__title {
      color: $color-black;
      font: $font-size-xlg $font-landing-medium;
    }
  }

  &-content {
    padding: 20px 23px 30px;

    @include mobile {
      padding-left: 16px;
      padding-right: 16px;
    }

    &__list {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
    }

    &__item {
      width: 110px;
      height: 37px;
      border: 1px solid $color-gallery;
      color: $color-black;
      font: $font-size-base $font-landing-global;
      border-radius: $borderRadius;
      margin: 0 15px 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 8px 15px;
      cursor: pointer;
      transition: border-color .15s ease-in;

      @include mobile-small {
        margin-left: 9px;
        margin-right: 9px;
      }

      &:hover {
        border-color: $color-dodger-blue;
      }

      &_active {
        border-color: $color-dodger-blue;
      }
    }
  }
}
</style>
